import { ROTransaction, RWTransaction } from '../../../db'
import { Context, Entity, Id, Order, PaginatedResult, Paging } from '../../../common'

export enum SalesPointType {
  FOOD = 'FOOD',
  NON_FOOD = 'NON_FOOD',
  MIXED = 'MIXED',
}

export function salesPointTypeName(type?: SalesPointType): string {
  switch (type) {
    case SalesPointType.FOOD:
      return 'Продовольственный'
    case SalesPointType.NON_FOOD:
      return 'Непродовольственный'
    case SalesPointType.MIXED:
      return 'Смешанный'
    default:
      return '-'
  }
}

export function salesPointTypeIndex(type?: SalesPointType): number {
  switch (type) {
    case SalesPointType.FOOD:
      return 0
    case SalesPointType.NON_FOOD:
      return 1
    case SalesPointType.MIXED:
      return 2
    default:
      return 3
  }
}

export interface SalesPoint extends Entity {
  name?: string
  inn?: string
  type?: SalesPointType
  maxPopulation?: number
  notificationMark?: string
  municipalEntityId: Id
  locality: string
  street?: string
  building?: string
  comment?: string
  area: number
  openingHours?: string
  phone?: string
  responsiblePersonName?: string
}

export type AddSalesPointOpts = {
  name?: string
  inn?: string
  type?: SalesPointType
  maxPopulation?: number
  notificationMark?: string
  id?: Id
  municipalEntityId: Id
  locality: string
  street?: string
  building?: string
  comment?: string
  area: number
  openingHours?: string
  phone?: string
  responsiblePersonName?: string
}

export type UpdateSalesPointOpts = {
  name?: string
  inn?: string
  type?: SalesPointType
  maxPopulation?: number
  notificationMark?: string
  municipalEntityId?: Id
  locality?: string
  street?: string
  building?: string
  comment?: string
  area?: number
  openingHours?: string
  phone?: string
  responsiblePersonName?: string
}

export interface SalesPointFilter {
  ids?: Id[]
  municipalEntityId?: Id
  /**
   * Full text search by locality, street, building, comment
   */
  search?: string
  withDeleted?: boolean
}

export enum SalesPointOrderFields {
  CREATED_AT = 'createdAt',
}

export interface SalesPointFindOptions {
  filter?: SalesPointFilter
  order?: Order<SalesPointOrderFields> | undefined
  paging?: Paging
}

export function salesPointGetAddress(salesPoint: SalesPoint) {
  return [salesPoint.locality, salesPoint.street, salesPoint.building].filter(val => val).join(', ')
}

export function prepareSalesPoint(salesPoint: SalesPoint): SalesPoint {
  return {
    ...salesPoint,
    area: Math.floor(salesPoint.area),
  }
}

export interface SalesPointsService {
  findAll(ctx: Context, opts?: SalesPointFindOptions): Promise<PaginatedResult<SalesPoint>>
  findById(ctx: Context, id: Id): Promise<SalesPoint | undefined>
  findByIdNonDeleted(ctx: Context, id: Id): Promise<SalesPoint | undefined>
  add(ctx: Context, opts: AddSalesPointOpts): Promise<Id>
  update(ctx: Context, id: Id, opts: UpdateSalesPointOpts): Promise<void>
  delete(ctx: Context, id: Id): Promise<void>
}

export interface SalesPointsRepository {
  findAll(tx: ROTransaction, opts?: SalesPointFindOptions): Promise<PaginatedResult<SalesPoint>>
  findById(tx: ROTransaction, id: Id): Promise<SalesPoint | undefined>
  findByIdNonDeleted(tx: ROTransaction, id: Id): Promise<SalesPoint | undefined>
  save(tx: RWTransaction, salesPoint: SalesPoint): Promise<void>
  delete(tx: RWTransaction, id: Id, deletedAt: Date): Promise<void>
}
